/* global locale */
import Api from '../cart_api'

export default {
  computed: {
    maxPackageQty() {
      return Math.min(this.item.inventory_on_site, 10)
    },

    orderItemAddHotelLink() {
      return `/${locale}/cart/items/${this.item.id}/hotels`
    },

    orderItemLinkText() {
      if (this.item.package_hotel_required) {
        return this.$t('cart.mustAddHotel')
      } else {
        return this.$t('cart.addHotel')
      }
    }
  },

  data() {
    return {
      ers: null,
      updating: false
    }
  },

  methods: {
    deleteItem() {
      if (this.updating) { return }
      this.ers = null
      this.updating = true

      Api.changeOrderItem(this.item.id, 'DELETE', null).then(item => {
        if (item.errors) { this.ers = item.errors }

        this.updating = false
      })
    },
    updateItem(newPackageQty) {
      this.ers = null
      this.updating = true
      let body = null
      if(this.$store) {
        body = JSON.stringify({ order_item: { quantity: newPackageQty, apply_credit:this.$store.state.checkout.applyCredit } })
      } else {
        body = JSON.stringify({ order_item: { quantity: newPackageQty } })
      }
      Api.changeOrderItem(this.item.id, 'PUT', body).then(item => {
        if (item.errors) { this.ers = item.errors }

        this.updating = false
      })
    }
  },

  props: ['item', 'showhotels']
}
